import {StyleSheet} from 'react-native';

import {
  onyx,
  onyxLight,
  onyxLighter,
  onyxLightest,
  ravenBlack,
} from '/theme/color/on.color';
import {mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: 'transparent',
    textShadowColor: 'transparent',
  },
});

export const emphases = StyleSheet.create({
  high: {
    color: onyx,
  },
  medium: {
    color: onyxLight,
  },
  low: {
    color: onyxLighter,
  },
  disabled: {
    color: onyxLightest,
  },
  dull: {
    color: mineShaft,
  },
  standard: {
    color: ravenBlack,
  },
});
export const variants = StyleSheet.create({
  xLarge: {
    fontSize: 28,
    lineHeight: 35,
  },
  large: {
    fontSize: 24,
    lineHeight: 28,
  },
  medium: {
    fontSize: 20,
    lineHeight: 24,
  },
  small: {
    fontSize: 16,
    lineHeight: 24,
  },
  heading: {
    fontSize: 16,
    lineHeight: 24,
  },
  subheading: {
    fontSize: 12,
    letterSpacing: 0.5,
    lineHeight: 16,
    textTransform: 'uppercase',
  },
  body: {
    fontSize: 14,
    lineHeight: 20,
  },
  button: {
    fontSize: 14,
    lineHeight: 20,
  },
  caption: {
    fontSize: 12,
    lineHeight: 14,
  },
  label: {
    fontSize: 10,
    lineHeight: 12,
    textTransform: 'uppercase',
  },
});
